'use client';

import * as Styled from './NotFoundPage.styled';
import goatChomp from './assets/goatChomp.json';

import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import React, { useEffect } from 'react';

type Props = Readonly<{
  homeURL?: string;
}>;

export const NotFoundPage: React.FC<Props> = ({ homeURL }) => {
  useEffect(() => {
    const err = new Error(`404 Not Found: ${window.location.pathname}`);
    Sentry.setTag('http.status_code', '404');
    Sentry.captureException(err, {
      level: 'error',
      extra: { path: window.location.pathname },
    });
  }, []);

  const finalHomeUrl = homeURL || window.location.origin;

  return (
    <Styled.Container>
      <Styled.GoatPen>
        <Styled.GoatFood>
          404
          <Styled.LottieContainer animationData={goatChomp} loop={true} />
        </Styled.GoatFood>
      </Styled.GoatPen>
      <h3>Not found?! Someone must have eaten that page.</h3>

      {finalHomeUrl && (
        <Styled.RedirectText>
          Let's goat you back <Link href={{ pathname: finalHomeUrl }}>home.</Link>
        </Styled.RedirectText>
      )}
    </Styled.Container>
  );
};
